import React, { useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
import { Button, Space, Badge } from 'antd';
import { MdRefresh } from 'react-icons/md';
import { FaFilter } from 'react-icons/fa6';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import WhenDesktop from 'src/components/layout/WhenDesktop';
import SecurityAdvisorContext from 'src/context/SecurityAdvisorContext';
//import PropTypes from 'prop-types';

const EventsFullWidgetBtns = () => {
  // const navigate = useNavigate();
  const { eventsFullWidgetFiltersOpen, setEventsFullWidgetReload, setEventsFullWidgetFiltersOpen, getEventsFullWidgetFiltersCountLabel } = useContext(SecurityAdvisorContext);

  return (
    <>
      <Space>
        <Button
          size='small'
          onClick={() => {
            setEventsFullWidgetReload(true);
          }}
        >
          <Space className='btn'>
            <MdRefresh />
            <WhenDesktop>Refresh</WhenDesktop>
          </Space>
        </Button>
        <Badge count={getEventsFullWidgetFiltersCountLabel()}>
          <Button
            size='small'
            onClick={() => {
              setEventsFullWidgetFiltersOpen(!eventsFullWidgetFiltersOpen);
            }}
          >
            <Space className='btn'>
              <FaFilter />
              <WhenDesktop>Filters</WhenDesktop>

              {eventsFullWidgetFiltersOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
            </Space>
          </Button>
        </Badge>
      </Space>
    </>
  );
};

EventsFullWidgetBtns.propTypes = {};

export default EventsFullWidgetBtns;
